import type { ISerialize } from '@/objects/ISerialize';

export class SignalrContestantTimesSubscribeParameters implements ISerialize {
    public ContestantID: number | null;

    public EventID: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { ContestantID?: number | null; EventID?: number }) {
        this.ContestantID = values.ContestantID ?? null;

        this.EventID = values.EventID ?? 0;
    }

    public serialize(): string {
        return '{' + `"ContestantID": ${JSON.stringify(this.ContestantID)}` + ',' + `"EventID": ${JSON.stringify(this.EventID)}` + '}';
    }

    /**
     * Creates an instance of SignalrContestantTimesSubscribeParameters from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { ContestantID?: number | null; EventID?: number }): SignalrContestantTimesSubscribeParameters {
        return new SignalrContestantTimesSubscribeParameters(values);
    }

    public static _FromServerJson(json: any): SignalrContestantTimesSubscribeParameters {
        return new SignalrContestantTimesSubscribeParameters({ ContestantID: json.ContestantID ?? null, EventID: json.EventID });
    }

    /**
     * Creates an instance of SignalrContestantTimesSubscribeParameters from another instance of SignalrContestantTimesSubscribeParameters.
     * @param other The SignalrContestantTimesSubscribeParameters you want to clone
     * @returns A cloned SignalrContestantTimesSubscribeParameters
     */
    public static FromOther(other: SignalrContestantTimesSubscribeParameters): SignalrContestantTimesSubscribeParameters {
        return SignalrContestantTimesSubscribeParameters._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SignalrContestantTimesSubscribeParameters.FromOther(this);
    }

    static NAME_OF_CLASS = 'SignalrContestantTimesSubscribeParameters';
}
